const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/content/$editId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { type Content_Single_Query$data } from '@/graphql/queries/Content.query';
import { setPageFullScreen } from '@/Components/templates/Page';
import { requireUserPostCaps } from '@/Router';
import { createFileRoute } from '@tanstack/react-router';
import './AddEditContent.less';
type Props = {
  data?: Content_Single_Query$data;
  isFallback?: boolean;
};
// loads the data

// shows the supsense loading

export const Route = createFileRoute('/dash/content/$editId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  beforeLoad: () => {
    requireUserPostCaps('catalog', 'edit_post', {
      to: '/dash/catalog'
    });
  },
  onEnter: () => {
    setPageFullScreen('on');
  },
  onLeave: () => {
    setPageFullScreen('off');
  }
});